import { diContainer } from '~setup/diContainer';
import serviceNames from '~setup/RatingsReviewsService';
import { ConfigStore } from '../../service-setup/ConfigStore';
import { IReviewUpdateConfig } from '../../internal/interfaces/IReviewUpdateConfig';

export class UpdateReviewConfigUseCase {
    private configStore: ConfigStore;
    private newConfig: IReviewUpdateConfig;

    constructor(updateConfig: IReviewUpdateConfig) {
        this.configStore = diContainer.get(serviceNames.configStore);
        this.newConfig = updateConfig;
    }

    public execute = async (): Promise<void> => {
        this.configStore.updateConfig({
            ratingsReviewsConfig: this.newConfig
        });
    };
}
